import { OverModel } from '@/modules/contract/entities/contants/over';
import { Markup, Over } from '@/modules/contract/entities/interfaces/over';

export const normalizeOver = (data: Markup[]) => {
  return OverModel.map((item: Over) => {
    const currMarkup = data.find((markup: Markup) => {
      const { ageBegin, ageEnd } = markup;
      const fixedId = `${ageBegin}-${ageEnd}`;

      return fixedId === item.id || (ageBegin === 59 && item.id.includes('59'));
    });

    if (currMarkup) {
      return {
        ...item,
        id: currMarkup.id,
        markup: currMarkup.markup,
        hasChange: false,
      };
    }
    return item;
  });
};
